import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';

import { RDMClientService } from '../../services/rdm-client.service';
import { BPNService } from '../../services/bpmn.service';

@Component({
  selector: 'app-amend-lease-details',
  templateUrl: './amend-lease-details.component.html',
})
export class AmendLeaseDetailsComponent implements OnInit {

  @Input() public defaultFormData: string;
  @Output() public submitedFormData = new EventEmitter<FormData>();

  public dropdownData:any[]= [];
  public chargeType= ''
  public chargeCode = '';

  public actions = [
    { label: 'Approved', code: 'Approved' },
    { label: 'Rejected', code: 'Rejected' },
    { label: 'More Info', code: 'More Info' }
  ];

  public amendLeaseFG: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private rdmClientService: RDMClientService,
    private bpmnService: BPNService
  // eslint-disable-next-line no-empty-function
  ) { }

  ngOnInit():void {
    // if (typeof this.defaultFormData === 'object') {
    this.onLoad(this.defaultFormData);
    this.getRDMData();

    // }
  }

  getBPNData(chargeType: string): void {
    this.bpmnService.getDamagesFacilityCharges({ 'violationType': chargeType }, 'inmPrmCalculateFines').subscribe((result:any) => {
      this.amendLeaseFG.patchValue({ charges: result.resultList[0].Fine + ' AED' });
      this.chargeCode = result.resultList[0].chargeCode;
    });
  }

  getChargeDetails($event:any): void {
    this.chargeType = $event;
    this.getBPNData($event);
  }

  getRDMData(): void {
    const rdmKey = { key: 'sez.lease.facility-charges-001' };
    forkJoin(this.rdmClientService.getLOVs(rdmKey.key)).subscribe((val) => {
      for (const value of val) {
        const data:any = this.rdmClientService.manipulateData(value);
        this.dropdownData.push(data);
      }
    });

  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onLoad(data:any):void {
    this.amendLeaseFG = this.formBuilder.group({
      damagedFacility: ['', [Validators.required]],
      charges: ['', [Validators.required]],
      selectedAction: ['', [Validators.required]],
      comments: [null]
    });
  }


  onSubmit():void {
    const formData:any = {
      'variables': {
        'action': { 'value': this.amendLeaseFG.value.selectedAction },
        'comments': { 'value': this.amendLeaseFG.value.comments },
        'violationType': { 'value': this.amendLeaseFG.value.damagedFacility },
        'Fine': { 'value': this.amendLeaseFG.value.charges.split(' ')[0] },
        'chargeCode': { 'value': this.chargeCode }
      }
    };
    this.submitedFormData.emit(formData);
  }
}
